import { styled } from "@linaria/react";
import { styleTokens } from "@ideally-ltd/design-tokens";
import bg from "../../assets/images/svg/Eye_Radial_Widescreen_02.svg";

const ErrorView = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background-color: white;
  background-image: url(${bg});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
  z-index: 9999;
  padding: 5rem 1.5rem;
  & > div {
    max-width: 36rem;
    h1 {
      font-family: ${styleTokens.fontFamily.Family};
      font-size: 3.125rem;
      font-style: normal;
      font-weight: 400;
      line-height: 105%; /* 3.28125rem */
      letter-spacing: -0.0125rem;
      margin-top: 1rem;
    }
    p {
      font-family: ${styleTokens.fontFamily.Inter};
      font-size: 1rem;
      font-style: normal;
      font-weight: 400;
      line-height: 1.5rem; /* 150% */
      letter-spacing: -0.005rem;
      a {
        color: ${styleTokens.Surface.Text.main};
      }
      margin-bottom: 2rem;
    }
  }
`;
const Small = styled.small`
  color: ${styleTokens.Surface.Text.sub};
  font-size: 1rem;
`;

export const ErrorViewStyle = {
  ErrorView,
  Small,
};
